module.exports = __webpack_public_path__ + "static/media/landingtop.722b59b7.png";